import { render } from "./HouseDetailsForLandPackage.vue?vue&type=template&id=f438b47e&scoped=true&ts=true&lang=pug"
import script from "./HouseDetailsForLandPackage.vue?vue&type=script&lang=ts&setup=true"
export * from "./HouseDetailsForLandPackage.vue?vue&type=script&lang=ts&setup=true"

import "./HouseDetailsForLandPackage.vue?vue&type=style&index=0&id=f438b47e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f438b47e"]])

export default __exports__